import React, { memo } from 'react';
import classnames from 'classnames';
import { RISKS_CONFIGS } from '@gp/pages/StudioDashboard/StudioOverall/components/RiskTag/constants';
import '@gp/pages/StudioDashboard/StudioOverall/components/RiskTag/index.scss';

const RiskTag: React.FC<IStudioOverallRiskTagProps> = (props) => {
  const {
    value,
    placeholder = '-',
    configs = RISKS_CONFIGS,
    style,
    className,
    ...remains
  } = props;

  const config = configs?.[value];

  return (
    <div
      {...remains}
      style={{
        ...style,
        color: config?.color,
        backgroundColor: config?.backgroundColor,
      }}
      className={classnames('font14 gp-studio-overall-risk-tag', className)}
    >
      {config?.text || placeholder}
    </div>
  );
};

export default memo(RiskTag);
